import React from 'react';
import { BespokeSectionHeader } from '@naf-simba/sections-headers';
import { BespokeHeaderProps } from './SectionPageHeader.types';

export const BespokeHeader = ({ title, ingress, runningHead, imageOrVideo }: BespokeHeaderProps) => (
  <BespokeSectionHeader title={title} ingress={ingress} runningHead={runningHead} imageOrVideo={imageOrVideo} />
);
